module.exports = __webpack_public_path__ + "static/media/flow-02.2258b92d.png";